module.exports = __webpack_public_path__ + "img/ren_bg.1b0fa843.png";